import { useEffect } from "react";

// Navigation
import AdminNav, { useVisibleAdminTabs } from "../components/AdminNav";

// Sub-pages
import UserAdminDashboard from "./UserAdminDashboard";
import AdminFlaggedRecords from "./AdminFlaggedRecords";
import AdminDeletedRecords from "./AdminDeletedRecords";
import AdminTools from "./AdminTools";
import AdminStats from "./AdminStats";
import AdminSuspicious from "./AdminSuspicious";
import AdminPatreon from "./AdminPatreon";
import AdminFeatured from "./AdminFeatured";
import AdminBenefits from "./AdminBenefits";

// Store
import adminStore from "../stores/Admin";

export default function AdminPage() {
    const activeTab = adminStore((state) => state.activeTab);
    const setActiveTab = adminStore((state) => state.setActiveTab);
    const visibleTabs = useVisibleAdminTabs();

    // The store remembers the last tab (and defaults to Users), so a feature
    // admin has to be moved onto a tab they are actually allowed to see.
    const canSeeActiveTab = visibleTabs.some((tab) => tab.key === activeTab);

    useEffect(() => {
        if (!canSeeActiveTab && visibleTabs.length > 0) {
            setActiveTab(visibleTabs[0].key);
        }
    }, [canSeeActiveTab, visibleTabs, setActiveTab]);

    return (
        <>
            <div className="p-2 p-md-0">
                <div className="py-2 px-2 px-md-5 mb-2">
                    <h2>Admin Dashboard</h2>
                    <AdminNav />
                    {canSeeActiveTab && (
                        <>
                            {activeTab === "users" && <UserAdminDashboard />}
                            {activeTab === "flagged" && <AdminFlaggedRecords />}
                            {activeTab === "deleted" && <AdminDeletedRecords />}
                            {activeTab === "tools" && <AdminTools />}
                            {activeTab === "stats" && <AdminStats />}
                            {activeTab === "suspicious" && <AdminSuspicious />}
                            {/* Site defaults vs campaign-tier matrix. Users page handles per-person overrides. */}
                            {activeTab === "benefits" && <AdminBenefits />}
                            {activeTab === "patreon" && <AdminPatreon />}
                            {activeTab === "featured" && <AdminFeatured />}
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
